import { ModalContent } from '@components/modal';

const VideoModal = ({ title, videoUrl }) => {
  // Convert YouTube watch URLs to embed URLs
  const getEmbedUrl = (url) => {
    if (!url) return '';

    try {
      const parsed = new URL(url, window.location.origin);
      const host = parsed.hostname.replace(/^www\./, '').toLowerCase();

      // youtube.com/watch?v=...
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const videoId = parsed.searchParams.get('v');
        if (videoId) return 'https://www.youtube.com/embed/' + videoId;
        if (parsed.pathname.includes('/embed/')) return parsed.href;
      }

      // youtu.be/...
      if (host === 'youtu.be') {
        const shortId = parsed.pathname.split('/').filter(Boolean)[0];
        if (shortId) return 'https://www.youtube.com/embed/' + shortId;
      }

      // dvidshub.net/video/{id}/...
      if (host === 'dvidshub.net') {
        if (parsed.pathname.includes('/video/embed/')) return parsed.href;

        const dvidsMatch = parsed.pathname.match(/\/video\/(\d+)/);
        if (dvidsMatch) {
          return 'https://www.dvidshub.net/video/embed/' + dvidsMatch[1];
        }

        // Root/other DVIDS pages are not frameable
        return '';
      }

      return parsed.href;
    } catch {
      return url;
    }
  };

  const embedUrl = getEmbedUrl(videoUrl);
  const isDvidsEmbed = /dvidshub.net\/video\/embed\//i.test(embedUrl);
  const videoPaddingBottom = isDvidsEmbed ? '62.5%' : '56.25%';

  return (
    <ModalContent hasCloseButton size='xl' title={title}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          paddingBottom: videoPaddingBottom,
          height: 0,
          overflow: 'hidden',
          backgroundColor: '#000',
          borderRadius: '4px',
        }}
      >
        <iframe
          src={embedUrl}
          title={title}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        />
      </div>
    </ModalContent>
  );
};

export default VideoModal;
